// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5b76bd7a","186":"83827632","225":"3a4e6bdc","344":"639397c1","372":"a6706a06","377":"d4d2f35e","738":"6886a212","841":"6ffa0044","856":"ab9c4105"}[chunkId] + ".chunk.js";
};